import { c as _c } from "react/compiler-runtime"; // hooks/useSearchParams.ts
import { useSearchParams as useNextSearchParams } from "next/navigation";
import { useCallback, useState } from "react";
import { parseUrlParams } from "@/utils";
export const useSearchParams = () => {
  const $ = _c(8);
  const searchParams = useNextSearchParams();
  const [selectedCategory, setSelectedCategory] = useState("");
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("s");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const searchQuery = t0;
  const updateURL = _temp4;
  let t1;
  if ($[2] !== searchParams) {
    t1 = filterData_0 => {
      const categoryParam = searchParams.get("kategoria");
      const priceFromParam = searchParams.get("cena_od");
      const priceToParam = searchParams.get("cena_do");
      const onSaleParam = searchParams.get("promocje") === "true";
      const {
        colors: colors_0,
        sizes: sizes_0,
        features: features_0
      } = parseUrlParams(searchParams, filterData_0);
      const defaultMinPrice_0 = Math.floor(Number(filterData_0.minPrice || 0));
      const defaultMaxPrice_0 = Math.floor(Number(filterData_0.maxPrice || 0));
      const minPriceFromUrl = priceFromParam ? parseInt(priceFromParam) : defaultMinPrice_0;
      const maxPriceFromUrl = priceToParam ? parseInt(priceToParam) : defaultMaxPrice_0;
      const categoriesStatic = [{
        label: "Kobieta",
        slug: "odziez-damska"
      }, {
        label: "M\u0119\u017Cczyzna",
        slug: "odziez-meska"
      }, {
        label: "Dzieci",
        slug: "odziez-dziecieca"
      }];
      const categoryToSet = categoryParam && categoriesStatic.find(cat => cat.slug === categoryParam) ? categoryParam : "";
      return {
        colors: colors_0,
        sizes: sizes_0,
        features: features_0,
        minPrice: minPriceFromUrl,
        maxPrice: maxPriceFromUrl,
        onSaleOnly: onSaleParam,
        category: categoryToSet
      };
    };
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const parseFiltersFromURL = t1;
  let t2;
  if ($[4] !== parseFiltersFromURL || $[5] !== searchQuery || $[6] !== selectedCategory) {
    t2 = {
      searchQuery,
      selectedCategory,
      setSelectedCategory,
      updateURL,
      parseFiltersFromURL
    };
    $[4] = parseFiltersFromURL;
    $[5] = searchQuery;
    $[6] = selectedCategory;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
function _temp(option) {
  return option.label.toLowerCase().replace(/\s+/g, "-");
}
function _temp2(option_0) {
  return option_0.label.toLowerCase().replace(/\s+/g, "-");
}
function _temp3(option_1) {
  return option_1.label.toLowerCase().replace(/\s+/g, "-");
}
function _temp4(colors, sizes, features, category, minPrice, maxPrice, onSaleOnly, filterData) {
  const url = new URL(window.location.href);
  ["kolor", "rozmiar", "cecha", "kategoria", "cena_od", "cena_do", "promocje"].forEach(param => {
    url.searchParams.delete(param);
  });
  if (colors.length > 0) {
    const colorSlugs = colors.map(_temp);
    url.searchParams.set("kolor", colorSlugs.join(","));
  }
  if (sizes.length > 0) {
    const sizeSlugs = sizes.map(_temp2);
    url.searchParams.set("rozmiar", sizeSlugs.join(","));
  }
  if (features.length > 0) {
    const featureSlugs = features.map(_temp3);
    url.searchParams.set("cecha", featureSlugs.join(","));
  }
  if (category) {
    url.searchParams.set("kategoria", category);
  }
  if (filterData) {
    const defaultMinPrice = Math.floor(Number(filterData.minPrice || 0));
    const defaultMaxPrice = Math.floor(Number(filterData.maxPrice || 0));
    if (minPrice !== defaultMinPrice) {
      url.searchParams.set("cena_od", minPrice.toString());
    }
    if (maxPrice !== defaultMaxPrice) {
      url.searchParams.set("cena_do", maxPrice.toString());
    }
  }
  if (onSaleOnly) {
    url.searchParams.set("promocje", "true");
  }
  window.history.replaceState({}, "", url.toString());
}